<rt-scrollable class="dialog-scroll-container">
  <div class="dialog-scroll-content">
    <div
      class="dialog-backdrop"
      (click)="!dialogConfig.disableClose && !dialogConfig.disableCloseOnBackdrop ? close() : null"
    ></div>
    <ng-container *ngIf="dialogConfig.backdropStyle === 'cover' && dialogCloseVisible">
      <ng-template [ngTemplateOutlet]="dialogClose"></ng-template>
    </ng-container>
    <rt-focus-trap>
      <div class="dialog-container">
        <div
          [style.width]="dialogConfig.width"
          [style.maxWidth]="dialogConfig.maxWidth"
          class="dialog-content"
        >
          <ng-template portalHost></ng-template>
          <ng-container *ngIf="dialogConfig.backdropStyle === 'default' && dialogCloseVisible">
            <ng-template [ngTemplateOutlet]="dialogClose"></ng-template>
          </ng-container>
        </div>
      </div>
    </rt-focus-trap>
  </div>
</rt-scrollable>

<ng-template #dialogClose>
  <div class="dialog-close dialog-backdrop-style-{{ dialogConfig.backdropStyle }}">
    <rt-dialog-close [closeTooltip]="dialogConfig.closeTooltip" (click)="close()"></rt-dialog-close>
  </div>
</ng-template>
